module.exports = __webpack_public_path__ + "img/c3.b1464722.png";